'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const ContactDealerMessage = require('bunsen/models/usercomm/ContactDealerMessage');
const User = require('../../../global/models/User');
const Price = require('bunsen/models/inventory/Price');
const contactHelpers = require('../helpers/contactHelpers');
const enabler = require('../../../global/utils/enabler');

class ContactMessageStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);
        this.reset();
    }

    reset(options = {}) {
        this.message = new ContactDealerMessage(null, options);
    }

    doneLoading(payload) {
        const { user, item, seller, copyText, isNetPrice } = payload;
        let canRequestNetPrice = false;
        this.reset({isNetPrice});
        if (user) {
            this.message.setFromUser(user);
            canRequestNetPrice = User.canRequestNetPrice();
        }
        if (item) {
            const uploadedNetPrice = item.getPriceByType(Price.TYPE_NET);
            const showingUploadedNetPrice = uploadedNetPrice
                && item.isFurniture()
                && canRequestNetPrice
                && enabler.isEnabled('enable_net_price');
            this.message.setItem(item);
            if (!showingUploadedNetPrice) {
                if (copyText.get('hardcodedTextBody', { passthrough: false })) {
                    this.message.set('textBody', copyText.get('hardcodedTextBody'));
                } else if (item.isPriceHidden()) {
                    this.message.set('textBody', copyText.get('pretextPur'));
                }
            }
            this.message.set('subject', contactHelpers.constructItemSubject({
                prefix: copyText.get('subjectItem'),
                item
            }));
        } else if (seller) {
            this.message.setSeller(seller);
            this.message.set('subject', copyText.get('subjectDealer'));
        }
        this.emitChange();
    }

    editField(payload) {
        this.message.set(payload.field, payload.value);
        this.emitChange();
    }

    editOptIn(payload) {
        const from = this.message.get('from');
        if (from) {
            from.setDiscloseEmail(payload.isOptIn);
        }
        this.emitChange();
    }

    userAuth(payload) {
        this.message.set('from.user', payload.user);
        this.emitChange();
    }

    prepareToSend(isUserToUser = false) {
        if (!isUserToUser) {
            if (this.message.get('from.user.id')) {
                return;
            }
            const userId = User.getUserId(true);
            if (userId) {
                this.message.set('from.user.id', userId);
            }
        }
    }
}

ContactMessageStore.storeName = 'ContactMessageStore';
ContactMessageStore.handlers = {
    'contact:loading:start': 'reset',
    'contact:message:fieldEdited': 'editField',
    'contact:loading:done': 'doneLoading',
    'contact:optIn:edited': 'editOptIn',
    'contact:auth:done': 'userAuth',
    'contact:sending:start': 'prepareToSend'
};

module.exports = ContactMessageStore;



// WEBPACK FOOTER //
// ./assets/js/contact/shared/stores/ContactMessageStore.es.js